export function checkIPhone(): boolean {
  return ["iPhone Simulator", "iPhone"].includes(navigator.platform);
}

export function checkIOS(): boolean {
  return (
    [
      "iPad Simulator",
      "iPhone Simulator",
      "iPod Simulator",
      "iPad",
      "iPhone",
      "iPod"
    ].includes(navigator.platform) ||
    // iPad on iOS 13 detection
    (navigator.userAgent.includes("Mac") && "ontouchend" in document)
  );
}

export const checkChrome = (): boolean => {
  return navigator.userAgent.indexOf("Chrome") > -1;
};

export const checkMobileChrome = (): boolean => {
  const userAgent = navigator.userAgent;

  return (
    /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
      userAgent
    ) && /Chrome/i.test(userAgent)
  );
};
